import DataTableV2 from "pages/data-table/data-table-v2";

const CRM = () => {
  return <DataTableV2 />;
};

export default CRM;